import React, {useEffect, useState} from 'react'
import {useSelector} from "react-redux";
import ProviderListItem from "./item";
import {useTranslation} from "react-i18next";
import associateServices from "../../services";
import SvgIcon from "../../components/svg-icon";

const ProvidersList = () => {

    const {t} = useTranslation()
    const {gameProviders} = useSelector(state => state.globalReducer)
    const {theme} = useSelector(state => state.globalReducer)
    const [providers, setProviders] = useState([])
    const [filtered, setFiltered] = useState([])
    useEffect(() => {
        if (theme === 'light') {
            const updates = gameProviders?.map(t => {
                t.image = t?.image?.replace(/light/g, "dark")
                return t
            })
            setProviders(updates)
        } else {
            const updates = gameProviders?.map(t => {
                t.image = t?.image?.replace(/dark/g, "light")
                return t
            })
            setProviders(updates)
        }
    }, [theme, gameProviders])


    const [search, setSearch] = useState('')
    const onChange = e => setSearch(e.target.value)


    useEffect(() => {
        setFiltered(providers?.filter(pp => pp.name?.toUpperCase()?.includes(search?.toUpperCase()) || pp.image?.toUpperCase()?.includes(search?.toUpperCase())))
    }, [search, providers])
    return (
        <>
            <div className="container section section--first">
                <div className="container-fluid d-flex align-items-center g-8 cursor-pointer">
                    <div className="col-12">
                        <h2 className="section__title">{t('general.providers')}</h2>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="filter">
                    <div className="filter__search filter__search--big mb-0">
                        <div className="search">
                            <input
                                value={search}
                                onChange={onChange}
                                name="search"
                                type="search" className="search__input" placeholder={t('casino.search')}/>
                            <button className="search__btn" type="button">
                                <SvgIcon id={'search'}/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="section pt-24 section--first">
                <div className="container">
                    <div className="row providers">

                        {
                            filtered.map(i => <ProviderListItem key={i.id} provider={i}/>)
                        }
                    </div>

                </div>
            </div>

        </>

    )

}

export default ProvidersList
